export default __webpack_public_path__ + "static/media/Hacksaw.2d8409e0.png";